type Content<T> = {
  yiContentType?: Array<{
    contentTo?: Array<T> | null
  } | null> | null
}

export function extractContentTypeTag<T> (content: Content<T>) {
  const yiContentTypeTagDetails = content.yiContentType?.[0]?.contentTo?.[0]
  return yiContentTypeTagDetails
}
